import { AlertOctagonIcon } from "lucide-react";
import { Button } from "react-aria-components";

import { trpc } from "@blis/trpc/react";

import { UserAvatar } from "@/components/UserAvatar";
import { Badge } from "@/components/ui/badge";
import { NavList, NavListItem } from "@/components/ui/nav-list";
import { Text } from "@/components/ui/text";
import { format } from "@/lib/utils";
import { useAccession } from "../AccessionProvider";
import { HoldDetailDialog } from "../dialogs/HoldDetailDialog";
import { DetailSection } from "./Section";

export function HoldSection() {
  const { accession } = useAccession();
  const holds = trpc.accession.holds.useQuery(accession.id);

  const activeHolds = holds.data?.filter((hold) => hold.isActive) || [];

  if (activeHolds.length === 0) {
    return null;
  }

  return (
    <DetailSection
      title="Active holds"
      hideBorder
      badge={<Badge size="sm">{activeHolds.length}</Badge>}
    >
      <NavList items={activeHolds} className="mt-1 border-b-0">
        {(hold) => (
          <NavListItem key={hold.id} asChild>
            <HoldDetailDialog key={hold.id} hold={hold}>
              <Button className="flex justify-between items-center w-full gap-4 border rounded-md px-4 h-10 shadow-xs cursor-pointer hover:bg-muted/50 [&+&]:mt-1 outline-hidden focus-visible:ring-2 ring-ring">
                <div className="flex items-center gap-2 min-w-0 flex-nowrap">
                  <AlertOctagonIcon className="shrink-0 text-red-600 size-4" />
                  <Text size="1" truncate elementType="span">
                    {hold.description}
                  </Text>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <Text size="1" mono muted className="shrink-0">
                    {format(hold.createdAt)}
                  </Text>
                  <UserAvatar tooltip user={hold.createdBy} />
                </div>
              </Button>
            </HoldDetailDialog>
          </NavListItem>
        )}
      </NavList>
    </DetailSection>
  );
}
